import React, { Component, Fragment } from 'react';

import { Error } from '../shared/Error/Error';
import { LoadingIndicator } from '../shared/LoadingIndicator/LoadingIndicator';
import MonitoredDocumentVersionsBrowser from './MonitoredDocumentVersions/MonitoredDocumentVersionsBrowser.container';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { formatDate } from '../../utils/dateUtils';

//import Can from '../Can';

// COMPONENT
class MonitoredDocumentBrowser extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { onInitialLoad } = this.props;

        try {
            onInitialLoad();
        } catch (err) {
            Swal({
                title: `Loading monitored document failed`,
                text: err,
                type: 'error',
            });
        }
    }

    render() {
        const { fetched, fetching, failed, monitoredDocument, documentId, backLink } = this.props;

        if (fetching && !fetched) {
            return <LoadingIndicator busy={fetching} />;
        } else if (failed) {
            return <Error message="Failed to fetch monitored document record" />;
        } else {
            return (
                <Fragment>
                    <div className="d-flex justify-content-between w-100">
                        <h6 className="card-subtitle text-muted">Document Monitoring</h6>
                        <span className="text-right small font-italic">
                            Last Checked:{' '}
                            {monitoredDocument.lastChecked
                                ? formatDate(monitoredDocument.lastChecked)
                                : 'N/A'}
                        </span>
                    </div>
                    <MonitoredDocumentVersionsBrowser documentId={documentId} backLink={backLink} />
                </Fragment>
            );
        }
    }
}

MonitoredDocumentBrowser.propTypes = {
    onInitialLoad: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    documentId: PropTypes.string.isRequired,
    monitoredDocument: PropTypes.object,
    monitoredDocumentVersions: PropTypes.array,
    failed: PropTypes.bool,
    backLink: PropTypes.string,
};

export default MonitoredDocumentBrowser;
